import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import profileImageReducer from "./profileImageSlice";
import wellnessReducer from "./wellnessSlice";
import bugReportReducer from "./bugReportSlice";
import liveEventsReducer from "./liveEventsSlice";
import profileReducer from "./profileSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    profile: profileReducer,
    profileImage: profileImageReducer,
    wellness: wellnessReducer,
    bugReport: bugReportReducer,
    liveEvents: liveEventsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
});
